import { Controller } from "@hotwired/stimulus";

// NicheBrowseController — switches between niche tabs in the Phase 0
// template picker. Thin coordinator: updates classes on tab buttons and
// show/hide on panels based on the active niche value.
export default class extends Controller {
  static targets = ["tab", "panel"];
  static values = { active: { type: String, default: "general" } };

  activeValueChanged(newValue) {
    this.tabTargets.forEach((tab) => {
      const key = tab.dataset.nicheKey;
      const isActive = key === newValue;
      tab.classList.toggle("border-indigo-500", isActive);
      tab.classList.toggle("text-indigo-600", isActive);
      tab.classList.toggle("border-transparent", !isActive);
    });
    this.panelTargets.forEach((panel) => {
      const key = panel.dataset.nicheKey;
      panel.classList.toggle("hidden", key !== newValue);
    });
  }

  select(event) {
    const niche = event.params.niche || event.currentTarget.dataset.nicheKey;
    if (!niche) return;
    if (event.currentTarget.disabled) return;
    this.activeValue = niche;
  }
}
